<template>
  <modal :value="value || internalValue"
         max-width="1000"
         content-class="admin-marketing-credits-modal modal-device"
         @input="emitInput"
         :has-padding="false">

    <div class="admin-marketing-credits-modal-body">
      <div class="admin-marketing-credits-modal-body-header">
        <p class="admin-marketing-credits-modal-body-item text-muted">{{ item.nome }}</p>
        <h1 class="admin-marketing-credits-modal-body-title">{{$t('message.admEstablishments.message.creditManagement')}}</h1>

        <div class="admin-marketing-credits-modal-body-summary">
          <div class="admin-marketing-credits-modal-body-summary-item">
            <p class="admin-marketing-credits-modal-body-summary-item-title">{{$t('message.creditManagement.message.currentPlan')}}</p>
            <v-progress-circular v-if="loading"
                                 class="admin-marketing-credits-modal-body-summary-item-loading"
                                 indeterminate
                                 color="primary"
                                 size="24"></v-progress-circular>
            <p v-else
               class="admin-marketing-credits-modal-body-summary-item-text">{{ planName }}</p>
          </div>

          <div class="admin-marketing-credits-modal-body-summary-item">
            <p class="admin-marketing-credits-modal-body-summary-item-title">{{$t('message.creditManagement.message.creditsMonth')}}</p>
            <v-progress-circular v-if="loading"
                                 class="admin-marketing-credits-modal-body-summary-item-loading"
                                 indeterminate
                                 color="primary"
                                 size="24"></v-progress-circular>
            <p v-else
               class="admin-marketing-credits-modal-body-summary-item-text"
               v-html="planCredits"></p>
          </div>

          <div class="admin-marketing-credits-modal-body-summary-item">
            <p class="admin-marketing-credits-modal-body-summary-item-title">{{$t('message.creditManagement.message.totalAvailable')}}</p>
            <v-progress-circular v-if="loading"
                                 class="admin-marketing-credits-modal-body-summary-item-loading"
                                 indeterminate
                                 color="primary"
                                 size="24"></v-progress-circular>
            <p v-else
               class="admin-marketing-credits-modal-body-summary-item-text"
               v-html="totalText"></p>
          </div>
        </div>
      </div>

      <sms-credit-list class="admin-marketing-credits-modal-body-credits"
                       :creditsList="creditsList"
                       :item="item"
                       :loading="loading"
                       @reload="fetchData" />

      <div class="admin-marketing-credits-modal-body-actions">
        <button class="btn btn-extra-round btn-primary"
                @click="toggleShowCreditAddModal('SMS')">
          {{$t('message.creditManagement.message.addSms')}}
        </button>

        <button class="btn btn-extra-round btn-primary"
                @click="toggleShowCreditAddModal('EMAIL')">
          {{$t('message.creditManagement.message.addEmail')}}
        </button>

        <!-- <button class="btn btn-extra-round btn-primary"
                @click="toggleShowCreditAddModal('WHATSAPP')">
            {{$t('message.creditManagement.message.addWhatsApp')}}
        </button> -->

        <button v-if="!hasPlan"
                class="btn btn-extra-round btn-primary"
                @click="toggleShowAddPlanModal">
          {{$t('message.creditManagement.message.linkPlan')}}
        </button>

        <button v-if="hasPlan"
                class="btn btn-extra-round"
                @click="showCancelPlanModal">
          {{$t('message.creditManagement.message.cancelPlan')}}
        </button>
      </div>
    </div>

    <marketing-plan-modal v-model="showAddPlanModal"
                          :item="item"
                          @input="$emit('change-modal-visibility', 'visible')"
                          @back="hideAddPlanModal"
                          @linked="hideAddPlanModalAndRefetch" />

    <sms-credit-add-form v-model="showCreditModal"
                         :item="item"
                         :type="creditAddType"
                         @input="$emit('change-modal-visibility', 'visible')"
                         @back="hideSmsCreditModal"
                         @added="setAddedCredits" />

    <confirmation-modal :value="showingCancelPlanModal"
                        confirm-label="Confirmar"
                        @confirm="cancelPlan"
                        @cancel="hideCancelPlanModal">
      <span slot="heading">
        {{$t('message.creditManagement.message.questionCancelPlan')}}
      </span>
      <span>
        {{$t('message.creditManagement.message.confirmationCancelPlan')}}
      </span>
    </confirmation-modal>
  </modal>
</template>

<script>
import ConfirmationModal from "@components/ConfirmationModal";
import MarketingPlanModal from "@components/modules/marketing/plan/modal/MarketingPlanModal";
import SmsCreditList from "@components/sms/SmsCreditList";
import SmsCreditAddForm from "@components/sms/SmsCreditAddForm";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    MarketingPlanModal,
    SmsCreditAddForm,
    SmsCreditList,
    ConfirmationModal,
    Modal,
  },
  data() {
    return {
      page: 0,
      showAddPlanModal: false,
      showCreditModal: false,
      currentPlan: undefined,
      creditTotal: {
        sms: 0,
        email: 0,
      },
      creditsList: [],
      showingCancelPlanModal: false,
      loading: false,
      internalValue: false,
      creditAddType: "SMS",
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    planName() {
      return this.currentPlan ? this.currentPlan.planName : "-";
    },
    planCredits() {
      return this.currentPlan
        ? `${this.currentPlan.smsAmount} SMS | ${this.currentPlan.emailAmount} E-mails`
        : "-";
    },
    totalText() {
      return `${this.creditTotal.sms} SMS | ${this.creditTotal.email} E-mails`;
    },
    hasPlan() {
      return !!this.currentPlan;
    },
    canEditSms() {
      return this.item.permitirUtilizarSMS;
    },
    isAdmin() {
      return this.$store.state.users.admin;
    },
  },  
  methods: {
    async reloadCredits() {
      await this.loadCredits();
    },
    setAddedCredits() {
      this.hideSmsCreditModal();
      this.fetchData();
    },
    async loadPlan() {
      try {
        const plan = await this.$api.marketing.account.plan.get({
          accountId: this.item.id,
        });

        this.currentPlan = plan;
      } catch (error) {
        this.currentPlan = undefined;
      }
    },
    async loadCredits() {
      try {
        this.loading = true;

        const [smsList, emailList] = await Promise.all([
          this.$api.marketing.account.credit.list({
            accountId: this.item.id,
            page: this.page,
            type: "SMS",
          }),
          this.$api.marketing.account.credit.list({
            accountId: this.item.id,
            page: this.page,
            type: "EMAIL",
          }),
          // this.$api.marketing.account.credit.list({
          //   accountId: this.item.id,
          //   page: this.page,
          //   type: "WHATSAPP",
          // }),
        ]);

        this.creditsList = [...smsList, ...emailList].sort(
          (creditA, creditB) => {
            return (
              new Date(creditB.creationDate) - new Date(creditA.creationDate)
            );
          }
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async loadTotal() {
      try {
        const [smsTotal, emailTotal] = await Promise.all([
          this.$api.marketing.account.credit.total({
            accountId: this.item.id,
            type: "SMS",
          }),
          this.$api.marketing.account.credit.total({
            accountId: this.item.id,
            type: "EMAIL",
          }),
          // this.$api.marketing.account.credit.total({
          //   accountId: this.item.id,
          //   type: "WHATSAPP",
          // }),
        ]);

        this.creditTotal = {
          sms: smsTotal,
          email: emailTotal,
          whatsApp: 0,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        this.loading = true;

        await this.loadPlan();
        await this.loadCredits();
        await this.loadTotal();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    hideModal() {
      this.emitInput(false);
      this.internalValue = false;
    },
    async emitInput(value) {
      if (!value) {
        this.internalValue = false;
      }
      this.$emit("input", value);
    },
    toggleShowAddPlanModal() {
      this.$emit('change-modal-visibility', 'hidden')
      this.showAddPlanModal = !this.showAddPlanModal;
    },
    toggleShowCreditAddModal(type) {
      this.creditAddType = type;
      this.$emit('change-modal-visibility', 'hidden')
      this.showCreditModal = !this.showCreditModal;    

    },
    hideAddPlanModal() {
      this.showAddPlanModal = false;
      this.$emit('change-modal-visibility', 'visible')
    },
    hideSmsCreditModal() {
      this.showCreditModal = false;      
      this.$emit('change-modal-visibility', 'visible')
    },
    showCancelPlanModal() {
      this.showingCancelPlanModal = true;
    },
    hideCancelPlanModal() {
      this.showingCancelPlanModal = false;
    },
    async cancelPlan() {
      await this.$api.marketing.account.plan.deleteLink({
        accountId: this.item.id,
      });

      this.hideCancelPlanModal();

      this.fetchData();
    },
    hideAddPlanModalAndRefetch() {
      this.hideAddPlanModal();
      this.fetchData();
    },
  },
  async mounted() {
    await this.fetchData()
  }
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.admin-marketing-credits-modal {
  .admin-marketing-credits-modal-body {
    padding: 20px 20px;

    .admin-marketing-credits-modal-body-title {
      text-align: center;
      font-size: 30px;
      font-weight: 600;
      margin-top: 0;
      margin-bottom: 40px;
      line-height: 1.1;
    }

    .admin-marketing-credits-modal-body-item {
      text-align: center;
      font-weight: 600;
      margin: 0;
    }

    .admin-marketing-credits-modal-body-summary {
      display: flex;
      gap: 40px;

      .admin-marketing-credits-modal-body-summary-item {
        flex: 1;
        text-align: center;
        border: 1px solid $color-muted;
        border-radius: 20px;
        padding: 10px;

        .admin-marketing-credits-modal-body-summary-item-title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 10px;
          color: rgba(#4d4f5c, 0.5);
        }

        .admin-marketing-credits-modal-body-summary-item-text {
          margin: 0;
          color: #4d4f5c;
          font-size: 16px;
          font-weight: 600;
        }

        .admin-marketing-credits-modal-body-summary-item-loading {
          margin-bottom: 20px;
        }
      }
    }

    .admin-marketing-credits-modal-body-credits {
      margin: 30px 0;
      max-height: 300px;
      overflow-y: scroll;
    }

    .admin-marketing-credits-modal-body-actions {
      display: flex;
      justify-content: space-between;

      .btn {
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
